/* global  __WATCH__:false */
import LoadDisplay from '../ui/loaddisplay/LoadDisplay';
import GameController from '../controller/GameController';
import { addGoogleAnalyticsPlugin } from 'analytics/GoogleAnalytics';
import { getGameFileLoadList } from 'utils/AssetpackUnloader';
import { DECODE_TIMEOUT_SPEED } from 'app/constants/AppConstants';

export default class Load extends Phaser.State {
  preload() {
    this.debug = false;

    this.loadComplete = false;

    this.loadBar = new LoadDisplay(this.game);
    this.game.add.existing(this.loadBar);

    this.assetsReady = false;

    this.game.load.onLoadStart.add(this.handleLoadStart, this);
    this.game.load.onFileStart.add(this.handleFileStart, this);
    this.loadAppAssetPacks();
  }

  handleFileStart(progress, key) {
    if (key.indexOf('-audioatlas') !== -1) {
      this.audioSprites.push(key.replace('-audioatlas', ''));
    }
  }

  handleLoadStart() {
    /*
     * getGameFileLoadList
     * If LOW-END device (doesRequireLightVersion)
     * parses the phaser loader _fileList and switched audio from 64 to 32 bit
     */
    getGameFileLoadList(this.game, this.debug);
  }

  loadAppAssetPacks() {
    this.game.load.baseURL = this.game.urls.getAssetsDirectory();
    this.game.load.crossOrigin = 'anonymous';

    this.audioSprites = [];

    const main = this.game.cache.getJSON('load_manifest').main;
    // load assetpacks
    const packs = main.packs;
    for (let i = 0; i < packs.length; i++) {
      const pack = packs[i];
      this.game.load.pack(pack.key, pack.path, null, this);
    }
  }

  loadUpdate() {
    this.loadBar.visible = true;
    this.loadBar.setProgress(this.game.load.progress / 100);
  }

  create() {
    this.assetsReady = true;
    this.game.sounds.startup();
  }

  update() {
    this.checkLoading();
  }

  checkLoading() {
    if (!this.loadComplete && this.assetsReady) {
      this.loadBar.setProgress(1);
      this.handleLoadComplete();
    }
  }

  handleLoadComplete() {
    if (!this.loadComplete) {
      this.loadComplete = true;
      this.game.app_config = this.game.cache.getJSON('app_config');
      this.setControllers();

      for (let i = 0; i < this.audioSprites.length; i++) {
        this.game.sounds.addAudioSprite({ id: this.audioSprites[i] });
      }

      for (let i = 0; i < this.game.app_config.audio.length; i++) {
        this.game.sounds.addSound(this.game.app_config.audio[i], this.game.app_config.audio[i]);
      }

      this.game.sounds.decode(this.audioSprites, this.audioDecoded, this);
      this.decodeSoundsCallback = this.game.time.events.add(DECODE_TIMEOUT_SPEED, () => {
        this.decodeSoundsCallback = null;
        if (this.loadBar) {
          this.loadBar.setProcessing();
        }
      });
    }
  }

  audioDecoded() {
    if (this.decodeSoundsCallback) {
      this.game.time.events.remove(this.decodeSoundsCallback);
      this.decodeSoundsCallback = null;
    }

    if (__WATCH__) {
      // skip the load complete animation during dev :)
      this.handleLoadAnimationComplete();
    } else {
      this.loadBar.onAnimationComplete.add(this.handleLoadAnimationComplete, this);
      this.loadBar.animateCompleteSequence({ delay: 500, duration: 200 });
    }

    // Add Springroll google analytics plugin to google analytics bridge
    const plugin = this.game.springRollApplication.getPlugin('GoogleAnalytics');
    addGoogleAnalyticsPlugin({ plugin });
  }

  setControllers() {
    this.game.controller = new GameController(this.game);
    this.game.controller.init();
  }

  handleLoadAnimationComplete() {
    this.game.controller.loadComplete();
    this.loadComplete = true;
  }

  shutdown() {
    this.game.load.onLoadStart.remove(this.handleLoadStart, this);
    this.game.load.onFileStart.remove(this.handleFileStart, this);
    this.loadBar.onAnimationComplete.remove(this.handleLoadAnimationComplete, this);
    this.loadBar.destroy();
    this.loadBar = null;
  }
}
